module.exports = __webpack_public_path__ + "public/img/down-gif.8b26ce76.gif";